import type { Preferences } from "sdk";
import { createSignal, createUniqueId, For } from "solid-js";
import { useCtx } from "@/app/context";
import { Dropdown } from "@/atoms/Dropdown";
import { RadioDot } from "@/atoms/icons";

type DateFormat = Preferences["frontend"]["date_format"];
type TimeFormat = Preferences["frontend"]["time_format"];

const langs = [
	{ labelNative: "english", labelLocalized: "english", id: "en-US" },
	{ labelNative: "englash", labelLocalized: "also english", id: "en-US2" },
	{ labelNative: "englosh", labelLocalized: "still english", id: "en-US3" },
];

export function Language() {
	const [selectedLang, setSelectedLang] = createSignal("en-US");
	const radioId = createUniqueId();
	const ctx = useCtx();
	const { t } = ctx;

	return (
		<div class="user-settings-lang">
			<h2>{t("user_settings.language")}</h2>
			<br />
			<div style="display:flex">
				<div style="flex: 1">{t("user_settings.date_format")}</div>
				<Dropdown<DateFormat>
					selected={ctx.preferences().frontend.date_format}
					onSelect={(value) => {
						if (value) {
							const c = ctx.preferences();
							ctx.setPreferences({
								...c,
								frontend: {
									...c.frontend,
									date_format: value,
								},
							});
						}
					}}
					options={[
						{ label: t("user_settings.date_format_auto"), item: "auto" },
						{ label: "dd/mm/yyyy", item: "standard" },
						{ label: "mm/dd/yyyy", item: "american" },
						{ label: "yyyy-mm-dd", item: "iso" },
					]}
				/>
			</div>
			<br />
			<div style="display:flex">
				<div style="flex: 1">{t("user_settings.time_format")}</div>
				<Dropdown<TimeFormat>
					selected={ctx.preferences().frontend.time_format}
					onSelect={(value) => {
						if (value) {
							const c = ctx.preferences();
							ctx.setPreferences({
								...c,
								frontend: {
									...c.frontend,
									time_format: value,
								},
							});
						}
					}}
					options={[
						{ label: t("user_settings.time_format_auto"), item: "auto" },
						{ label: "12h", item: "12h" },
						{ label: "24h", item: "24h" },
					]}
				/>
			</div>
			<br />
			<ul class="langs">
				<For each={langs}>
					{(lang) => (
						<label class="lang">
							<input
								type="radio"
								name={radioId}
								onInput={() => setSelectedLang(lang.id)}
							/>
							<RadioDot checked={selectedLang() === lang.id} />
							<div>
								<div>{lang.labelLocalized}</div>
								<div class="dim">{lang.labelNative}</div>
							</div>
						</label>
					)}
				</For>
			</ul>
		</div>
	);
}
